<template>
<div class="content">
  <el-tabs class="tabLv3" type="border-card" v-model="tabName"><i class="lt"></i><i class="rt"></i>
    <el-tab-pane name="xjrwgl">
      <span slot="label"><i class="iconfont iconcheck"></i><i class="border"></i> 我的代办 </span>
      <normalNav :parent="self">
        <!-- <button class="GreenSmBtn download" @click="editDialogVisible=true">下发</button> -->
      </normalNav>
      <div class="searchForm1">
         <searchForm
            :items="items"
            :formPlus="form_xjrwgl"
            ref="searchForm_xjrwgl"
          >
          </searchForm>
      </div>
      <div class="tableWrapper">
       <easyTable apiUrl="extra/activiti/asset/task" :parent="self" :config="config" :other="other" ref="table_xjrwgl">
          <template slot="last">
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row,2)" type="text" size="small" v-if="scope.row.taskName==='归还'&&scope.row.taskType==='personal'">归还</el-button>
                <el-button @click="handleClick(scope.row,1)" type="text" size="small" v-if="scope.row.taskType!=='personal'">通过</el-button>
                <el-button @click="handleClick(scope.row,0)" type="text" size="small" v-if="scope.row.taskType!=='personal'">拒绝</el-button>
                <el-button type="text" size="small" @click="details(scope.row)">详细</el-button>
              </template>
            </el-table-column>
          </template>
        </easyTable>
      </div>

      <el-dialog class="editDialog" title="详情" :visible.sync="editDialogVisible" :close-on-click-modal="false">
        <section class="list" style="height: 300px;">
          <el-steps direction="vertical" :active="active">
            <el-step v-for="(i,index) in detailsList" :key="index" :title="i.name+' '+(i.assigneeName||'暂无')" :description="'开始时间:'+i.startTime+' '+'结束时间:'+(i.endTime||'暂无')">123</el-step>
          </el-steps>
        </section>

        <div slot="footer" class="dialog-footer">
          <el-button class="cancelButton" type="primary" @click="editDialogVisible = false">返回</el-button>
        </div>
      </el-dialog>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import {
  obj2urlsp,
  descriptor
} from "utils";
export default {
  data() {
    return {
      tabName: 'xjrwgl',
      tzs: [],
      form_xjrwgl: {},
      editLoading: true,
      editDialogVisible: false,
      data: {},
      other: {},
      form1: {},
      detailsList:[],
      active:0
    };
  },
  computed: {
    items() {
      const that = this;
      return [{
          type: "input",
          prop: "assetName",
          label: "资产名称",
          placeholder: "请输入资产名称",
        },
        {
          type: "input",
          prop: "userName",
          label: "申请人",
          placeholder: "请输入申请人姓名",
        },
        {
          type: "select",
          prop: "processState",
          label: "资产状态",
          placeholder: "请输入资产状态",
          option: {
            option: [{label:'待审核',value:'审核'},{label:'待批准',value:'批准'},{label:'待归还',value:'归还'}],
          }
        },
      ]
    },
    self() {
      return this;
    },
    config() {
      return [{
        prop:(row)=>{
          console.log(row);
          return 'zgx_dev_'+this.buling(row.assetId,5)
        },
        label: '资产编号'
      }, {
        prop: 'assetName',
        label: '资产名称'
      }, {
        prop: 'userName',
        label: '申请人'
      }, {
        prop: 'createTime',
        label: '申请时间'
      }, {
        prop: 'updateTime',
        label: '更新时间'
      }, {
        label: '状态',
        prop:(row)=>{
          return '待'+row.taskName
        },
      }];
    },
    download() {
      let data = this.formData;
      this.$axios
        .post(
          process.env.API_HOST +
          "/operation/alarmCountApi/export/exportAlarmCount?"  +
            "companyId=" +
            localStorage.getItem("companyId") +
            "&userId=" +
            this.$store.state.user.id +
            "&systemId=" +
            data.systemId +
            "&areaId=" +
            data.areaId +
            "&typeId=" +
            data.typeId +
            "&startTime=" +
            data.startTime +
            "&endTime=" +
            data.endTime,
        )
        .then(res => {
          // //console.log(res);
        });
    },
    rule() {
      let that = this;
      return {
        takeDeptId: descriptor(new Map([
          [true, "请选择负责部门"]
        ]), "blur"),
        takeEmpId: descriptor(new Map([
          [true, "请选择负责人员"]
        ]), "blur"),
        dicTypeDataId: descriptor(new Map([
          [true, "请选择类型"]
        ]), "blur"),
        url: descriptor(new Map([
          [true, "请上传文件"]
        ]), "blur")
      }
    }
  },
  methods: {
    reset_xjrwgl(fn) {
      fn();
      this.form_xjrwgl = {};
    },
    search_xjrwgl(fn) {
      fn();
    },
    handleClick(scope,type){
      //1通过，0拒绝，2归还
      if(type===0){
        this.$axiospost(`extra/activiti/asset/audit?taskId=${scope.taskId}&auditState=false`).then(res => {
          this.$message.success("拒绝成功！");
          this.$refs["table_xjrwgl"].getData();
        })
      }
      if(type===1){
        this.$axiospost(`extra/activiti/asset/audit?taskId=${scope.taskId}&auditState=true`).then(res => {
          this.$message.success("通过成功！");
          this.$refs["table_xjrwgl"].getData();
        })
      }
      if(type===2){
        this.$axiospost(`extra/activiti/asset/giveBack?assetId=${scope.assetId}`).then(res => {
          if (res.data.status === "10000" || res.data.status === 10000) {
          this.$message.success("归还成功！");
        }
          this.$refs["table_xjrwgl"].getData();
        })
      }
    },
    details(scope){
      this.$axiosget(`extra/activiti/asset/task/detail?processInstanceId=${scope.processInstanceId}`).then(res => {
        this.detailsList=res.data.data
        this.active=this.detailsList.findIndex(i=>i.assignee===null)
        this.editDialogVisible=true
      })
    },
    buling(num, length) {
      for(var len = (num + "").length; len < length; len = num.length) {
      num = "0" + num;
      }
      return num;
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    nextCompany: () => import("public/nextCompany")
  },
  mounted() {
    this.$axiosget('operation/dictionaryData/queryByKey', {
      params: {
        key: "alerts"
      }
    }).then(res => {
      this.tzs = res.data.data;
    })
  }
};
</script>

<style lang="less" scoped>
.point {
  span {
    padding-left: 5px;
    color: #FFF;
    font-size: 14px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-left: 2px solid #35b9f7;
  }

  border-bottom:1px solid #777;
  line-height: 36px;
  margin-top: 15px;
  margin-bottom: 15px;
}
/deep/ .el-step__description.is-process,/deep/ .el-step__title.is-process{
  color: #6588af;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/assetManagement/myAgent.vue